export default __webpack_public_path__ + "static/media/PSE.db9eeb84.svg";